import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ss-pagina-alerta" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-12 ant-col-xl-12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "ss-imagem-pagina-alerta",
    src: "/static/img/ilustracoes/sem-permissao.svg"
  })
], -1)
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_5 = { class: "ss-mensagem-pagina-alerta" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, "Sua assinatura não está ativa!", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Por favor entre em contato conosco.", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-pagina-alerta",
  target: "_blank",
  href: "https://sabresistemas.com.br/fale-com-consultor/"
}, "Consultor", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              class: "ant-btn ant-btn-lg ant-btn-primary ss-botao-pagina-alerta",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.voltar && _ctx.voltar(...args)))
            }, "Voltar"),
            _hoisted_8
          ])
        ])
      ])
    ])
  ]))
}